export default "__VITE_ASSET__txBwkURW__"